module.exports = "<p>\n  item-tracking-otif-detailed works!\n</p>\n"